import axios from "axios";
import { API_BASE_URL } from '../../config/apiConfig';

// ==============================================
// SALARY DEDUCTION & ARREAR MANAGEMENT APIs
// ==============================================

// 1. Get Salary Deduction Employees (GET) - Search by prefix
export const getSalaryDeductionEmp = async (params) => {
    try {
        const { prefix } = params;

        if (!prefix) throw new Error('Prefix is required');

        const queryParams = new URLSearchParams({ Prefix: prefix });

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetSalaryDeductionEmp?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// 2. Get Salary Pending Years for Employee (GET)
export const getSalaryPendingYear = async (params) => {
    try {
        const { empRefNo } = params;

        if (!empRefNo) throw new Error('Employee Reference Number is required');

        const queryParams = new URLSearchParams({ Emprefno: empRefNo });

        const response = await axios.get(
            `${API_BASE_URL}/HR/SalaryPendingYear?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// 3. Bind Salary Deduction Months (GET)
export const bindSalaryDeductionMonths = async (params) => {
    try {
        const { year, empRefNo } = params;

        if (!year)     throw new Error('Year is required');
        if (!empRefNo) throw new Error('Employee Reference Number is required');

        const queryParams = new URLSearchParams({ Year: year, Emprefno: empRefNo });

        const response = await axios.get(
            `${API_BASE_URL}/HR/BindSalaryDeductionMonths?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// 4. Get Employee Deductions For Month (GET)
export const getEmpDeductionsForMonth = async (params) => {
    try {
        const { year, empRefNo, month } = params;

        if (!year)     throw new Error('Year is required');
        if (!empRefNo) throw new Error('Employee Reference Number is required');
        if (!month)    throw new Error('Month is required');

        const queryParams = new URLSearchParams({ Year: year, Emprefno: empRefNo, Month: month });

        const response = await axios.get(
            `${API_BASE_URL}/HR/GETEmpDeductionsForMonth?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// 5. Save Single Employee Salary Deduction (POST) - Calls spInsertSingleEmpSalaryDeduction
export const saveSingleEmpSalaryDeduction = async (params) => {
    try {

        // ── Validate required fields ──────────────────────────────────────────
        if (!params.empRefNo)         throw new Error('Employee Reference Number is required');
        if (!params.month)            throw new Error('Month is required');
        if (!params.year)             throw new Error('Year is required');
        if (!params.deductionHeads)   throw new Error('Deduction Heads are required');
        if (!params.deductionAmounts) throw new Error('Deduction Amounts are required');
        if (!params.ccCode)           throw new Error('Cost Center Code is required');
        if (!params.roleId)           throw new Error('Role ID is required');
        if (!params.createdBy)        throw new Error('Created By is required');

        // ── Build payload matching spInsertSingleEmpSalaryDeduction SP ────────
        // SP Parameters:
        //   @Emprefno        → EmpRefno        (string)
        //   @Month           → Month           (int)
        //   @Year            → Year            (int)
        //   @DeductionHeads  → DeductionHeads  (string)
        //   @DeductionAmounts→ DeductionAmounts(string)
        //   @CCCode          → CCCode          (string)
        //   @Roleid          → RoleId          (int)
        //   @Createdby       → CreatedBy       (string)
        //   @AddStatus (output)
        const payload = {
            EmpRefno: params.empRefNo.toString(),
            Month: parseInt(params.month),
            Year: parseInt(params.year),
            DeductionHeads: params.deductionHeads,
            DeductionAmounts: params.deductionAmounts,
            CCCode: params.ccCode.toString(),
            RoleId: parseInt(params.roleId),
            CreatedBy: params.createdBy.toString()
        };


        const response = await axios.post(
            `${API_BASE_URL}/HR/SaveSingleEmpSalaryDeduction`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );

        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save Single Employee Salary Deduction';
    }
};

// 6. Update Single Employee Salary Deduction (PUT) - Calls UpdateSingleEmpSalaryDeduction
export const updateSingleSalaryDeduction = async (params) => {
    try {

        // ── Validate required fields ──────────────────────────────────────────
        if (!params.empRefNo)              throw new Error('Employee Reference Number is required');
        if (!params.empTransactionRefNo)   throw new Error('Employee Transaction Reference Number is required');
        if (!params.deductionHeads)        throw new Error('Deduction Heads are required');
        if (!params.deductionAmounts)      throw new Error('Deduction Amounts are required');
        if (!params.ccCode)                throw new Error('Cost Center Code is required');
        if (!params.roleId)                throw new Error('Role ID is required');
        if (!params.createdBy)             throw new Error('Created By is required');

        // ── Build payload matching UpdateSingleEmpSalaryDeduction SP ─────────
        // SP Parameters:
        //   @Emprefno              → EmpRefno              (string)
        //   @EmpTransactionRefNo   → EmpTransactionRefNo   (int)
        //   @DeductionHeads        → DeductionHeads        (string)
        //   @DeductionAmounts      → DeductionAmounts      (string)
        //   @CCCode                → CCCode                (string)
        //   @Roleid                → RoleId                (int)
        //   @Createdby             → CreatedBy             (string)
        //   @AddStatus (output)
        const payload = {
            EmpRefno: params.empRefNo.toString(),
            EmpTransactionRefNo: parseInt(params.empTransactionRefNo),
            DeductionHeads: params.deductionHeads,
            DeductionAmounts: params.deductionAmounts,
            CCCode: params.ccCode.toString(),
            RoleId: parseInt(params.roleId),
            CreatedBy: params.createdBy.toString()
        };


        const response = await axios.put(
            `${API_BASE_URL}/HR/UpdateSingleSalaryDeduction`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );

        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to update Single Employee Salary Deduction';
    }
};

// 7. Save Salary Deductions Bulk (PUT) - Calls spInsertEmpSalaryDeduction
export const saveSalaryDeductions = async (params) => {
    try {

        // ── Validate required fields ──────────────────────────────────────────
        if (!params.ids)        throw new Error('Ids are required');
        if (!params.empRefNos)  throw new Error('Employee Reference Numbers are required');
        if (!params.empTransNos)throw new Error('Employee Transaction Numbers are required');
        if (!params.months)     throw new Error('Months are required');
        if (!params.years)      throw new Error('Years are required');
        if (!params.payDates)   throw new Error('Pay Dates are required');
        if (!params.ccCodes)    throw new Error('Cost Center Codes are required');
        if (!params.roleId)     throw new Error('Role ID is required');
        if (!params.createdBy)  throw new Error('Created By is required');

    
        const payload = {
            Ids: params.ids.toString(),
            EmpRefnos: params.empRefNos.toString(),
            EmpTransNos: params.empTransNos.toString(),
            Months: params.months.toString(),
            Years: params.years.toString(),
            PayDates: params.payDates.toString(),
            CCCodes: params.ccCodes.toString(),
            RoleId: parseInt(params.roleId),
            CreatedBy: params.createdBy.toString()
        };


        const response = await axios.put(
            `${API_BASE_URL}/HR/SaveSalaryDeductions`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );

        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save Salary Deductions';
    }
};

// 8. Get Pending Salary Deductions (GET) - Fetches single-emp saved records for bulk submission table
export const getPendingSalaryDeductions = async () => {
    try {

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetPendingSalaryDeductions`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// 9. Get Salary Deductions by EmpTransactionRefNo (GET)
export const getSalaryDeductionsByEmpTransNo = async (params) => {
    try {
        const { empTransactionRefNo, empRefNo } = params;

        if (!empTransactionRefNo) throw new Error('Employee Transaction Reference Number is required');
        if (!empRefNo)            throw new Error('Employee Reference Number is required');

        const queryParams = new URLSearchParams({
            EmpTransactionRefNo: empTransactionRefNo,
            EmpRefNo: empRefNo,
        });

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetSalaryDeductionsbyEmpTransNo?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};


// ==============================================
// ARREAR MANAGEMENT APIs
// ==============================================

// 10. Get Arrear Heads (GET)
export const getArearHeads = async () => {
    try {

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetArearHeads`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// 11. Get Arrears Cost Centers for Employee (GET)
export const getArearsCC = async (params) => {
    try {
        const { empRefNo } = params;

        if (!empRefNo) throw new Error('Employee Reference Number is required');

        const queryParams = new URLSearchParams({ Emprefno: empRefNo });

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetArearsCC?${queryParams}`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};


// 12. Get Pending Salary Arrears (GET)
export const getPendingSalaryArear = async () => {
    try {

        const response = await axios.get(
            `${API_BASE_URL}/HR/GetPendingSalaryArear`,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error;
    }
};

// 13. Update Single Employee Arrear (PUT) - Calls spUpdateArear
export const updateArear = async (params) => {
    try {

        // ── Validate required fields ──────────────────────────────────────────
        if (!params.empRefNo)              throw new Error('Employee Reference Number is required');
        if (!params.empTransactionRefNo)   throw new Error('Employee Transaction Reference Number is required');
        if (!params.totalAmount)           throw new Error('Total Amount is required');
        if (!params.ccJsonString)          throw new Error('CC JSON String is required');
        if (!params.roleId)                throw new Error('Role ID is required');
        if (!params.createdBy)             throw new Error('Created By is required');

        // ── Build payload matching spUpdateArear SP ───────────────────────────
        // SP Parameters:
        //   @Emprefno              → EmpRefno              (string)
        //   @EmpTransactionRefNo   → EmpTransactionRefNo   (int)
        //   @TotalAmount           → TotalAmount           (string)
        //   @CCJsonstring          → CCJsonstring          (string)
        //   @Roleid                → RoleId                (int)
        //   @Createdby             → CreatedBy             (string)
        //   @AddStatus (output)
        // Note: @ArearAmount and @BudgetCC are commented out in the SP — omitted here.
        const payload = {
            EmpRefno:            params.empRefNo.toString(),
            EmpTransactionRefNo: parseInt(params.empTransactionRefNo),
            TotalAmount:         params.totalAmount.toString(),
            CCJsonstring:        params.ccJsonString,
            RoleId:              parseInt(params.roleId),
            CreatedBy:           params.createdBy.toString(),
        };


        const response = await axios.put(
            `${API_BASE_URL}/HR/UpdateArear`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to update Arrear';
    }
};

// 14. Save Salary Arrears Bulk (PUT) - Calls spInsertEmpSalaryArear
export const saveSalaryArears = async (params) => {
    try {

        // ── Validate required fields ──────────────────────────────────────────
        if (!params.ids)         throw new Error('Ids are required');
        if (!params.empRefNos)   throw new Error('Employee Reference Numbers are required');
        if (!params.empTransNos) throw new Error('Employee Transaction Numbers are required');
        if (!params.months)      throw new Error('Months are required');
        if (!params.years)       throw new Error('Years are required');
        if (!params.payDates)    throw new Error('Pay Dates are required');
        if (!params.ccCodes)     throw new Error('Cost Center Codes are required');
        if (!params.roleId)      throw new Error('Role ID is required');
        if (!params.createdBy)   throw new Error('Created By is required');

       
        const payload = {
            Ids:        params.ids.toString(),
            EmpRefnos:  params.empRefNos.toString(),
            EmpTransNos:params.empTransNos.toString(),
            Months:     params.months.toString(),
            Years:      params.years.toString(),
            PayDates:   params.payDates.toString(),
            CCCodes:    params.ccCodes.toString(),
            RoleId:     parseInt(params.roleId),
            CreatedBy:  params.createdBy.toString(),
        };


        const response = await axios.put(
            `${API_BASE_URL}/HR/SaveSalaryArears`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );
        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save Salary Arrears';
    }
};

// 15. Save Arrear (POST) - Calls spInsertArearHead
export const saveArear = async (params) => {
    try {

        // ── Validate required fields ──────────────────────────────────────────
        if (!params.empRefNo)      throw new Error('Employee Reference Number is required');
        if (!params.month)         throw new Error('Month is required');
        if (!params.year)          throw new Error('Year is required');
        if (!params.salaryHead)    throw new Error('Salary Head (HeadName) is required');
        if (!params.totalAmount)   throw new Error('Total Amount (HeadAmount) is required');
        if (!params.ccCode)        throw new Error('Cost Center Code is required');
        if (!params.roleId)        throw new Error('Role ID is required');
        if (!params.createdBy)     throw new Error('Created By is required');
        if (!params.ccJsonString)  throw new Error('CC JSON String is required');

        // ── Build payload matching spInsertArearHead SP ───────────────────────
        // SP Parameters:
        //   @Emprefno      → EmpRefno      (string)
        //   @Month         → Month         (int)
        //   @Year          → Year          (int)
        //   @HeadName      → SalaryHead    (string)
        //   @HeadAmount    → TotalAmount   (string)
        //   @CCCode        → CCCode        (string)
        //   @Roleid        → RoleId        (int)
        //   @Createdby     → CreatedBy     (string)
        //   @CCJsonstring  → CCJsonstring  (string)
        //   @AddStatus (output)
        const payload = {
            EmpRefno: params.empRefNo.toString(),
            Month: parseInt(params.month),
            Year: parseInt(params.year),
            SalaryHead: params.salaryHead.toString(),
            TotalAmount: params.totalAmount.toString(),
            CCCode: params.ccCode.toString(),
            RoleId: parseInt(params.roleId),
            CreatedBy: params.createdBy.toString(),
            CCJsonstring: params.ccJsonString
        };


        const response = await axios.post(
            `${API_BASE_URL}/HR/SaveArear`,
            payload,
            { headers: { 'Content-Type': 'application/json' } }
        );

        return response.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || 'Failed to save Arrear';
    }
};